module.exports = __webpack_public_path__ + "img/banner.825ef310.jpg";